import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'jl-design-system/elements/checkbox/Checkbox';
import { connect } from 'react-redux';
import { giftReceiptSelected } from '../../redux/actions/delivery/deliveryActions';

export class GiftReceipt extends PureComponent {
  static propTypes = {
    ...Checkbox.propTypes,
    giftReceiptSelected: PropTypes.func,
    // the onChange function here comes from redux form
    onChange: PropTypes.func,
  };

  static defaultProps = {
    ...Checkbox.defaultProps,
    giftReceiptSelected: window.defaultFunc,
    onChange: window.defaultFunc,
  };

  render() {
    const {
      giftReceiptSelected,
      onChange,
    } = this.props;

    return (
      <>
        <h4>Is this a gift?</h4>
        <Checkbox
          {...this.props}
          onChange={(evt) => {
            onChange(evt);

            const isSelected = !!evt;
            giftReceiptSelected(isSelected);
          }}
        />
      </>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
  };
}

export function mapDispatchToProps() {
  return {
    giftReceiptSelected,
  };
}

export default connect((state, ownProps) => mapStateToProps(state, ownProps), mapDispatchToProps())(GiftReceipt);
